import styled from '@emotion/styled';
import { Button, Modal } from 'antd';
import dayjs from 'lib/dayjs';
import { memo, useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';

function TradeMemoRecord({
  sellerMemosOperationLog = [],
}: Pick<Conversation.Trade.Vo, 'sellerMemosOperationLog'>) {
  const { t } = useTranslate();

  const [visible, setVisible] = useState(false);

  const logList = useMemo(() => {
    return [...sellerMemosOperationLog].reverse().map(({ userName, operateTimeMs, raw }) => {
      let content = '';

      try {
        content = JSON.parse(raw).sellerMemos;
      } catch (e) {}

      return (
        <Item key={operateTimeMs}>
          <section>
            <h4>{`${userName} ${t('scene.chatWorkspace.orderTab.notes.action.edit')}`}</h4>
            <span>{dayjs(Number(operateTimeMs)).format('YYYY-MM-DD HH:mm:ss')}</span>
          </section>
          <div>{content || '-'}</div>
        </Item>
      );
    });
  }, [sellerMemosOperationLog, t]);

  return (
    <>
      <Button type="link" size="small" onClick={() => setVisible(true)}>
        {t('scene.chatWorkspace.orderTab.notes.title.history')}
      </Button>
      <Modal
        title={t('scene.chatWorkspace.orderTab.notes.title.history')}
        width={602}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={false}
      >
        {logList}
      </Modal>
    </>
  );
}

const Item = styled.div`
  position: relative;
  padding-left: 18px;
  padding-bottom: 14px;
  > section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    > h4 {
      margin-bottom: 0;
      font-weight: normal;
    }
    > span {
      font-size: 12px;
      color: #84868c;
    }
  }
  > div {
    padding: 8px;
    background: #f7f9fa;
  }
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    top: 8px;
    left: -4px;
    width: 9px;
    height: 9px;
    background: #d3d7e0;
    border-radius: 5px;
  }
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 12px;
    left: 0;
    width: 0;
    height: 100%;
    border-left: dashed 1px #d3d7e0;
  }
  &:last-of-type {
    &::after {
      display: none;
    }
  }
`;

export default memo(TradeMemoRecord);
